// constants
import { applicationProperties } from 'constants/scripts';
import { UNIT_TYPES } from 'constants/unitTypes';

// util
import { convertForLocaleScalar } from 'util/unitConversion';
import { getApplicationProperty } from 'util/applications';

export const getPlantingRates = (fertilizerApplications, seedApplications, cropNominalWeight) => {
  const rawLiquidRate = getApplicationProperty(fertilizerApplications, applicationProperties.RATE);
  // If raw liquid rate doesn't exist, assume it's zero
  const liquidRate = convertForLocaleScalar({
    quantity: rawLiquidRate ? rawLiquidRate.q : 0,
    unit: rawLiquidRate ? rawLiquidRate.u : UNIT_TYPES.gal_ac,
    unitType: 'volumetric-density'
  });

  const rawSeedRate = getApplicationProperty(seedApplications, applicationProperties.RATE);
  const seedRate = convertForLocaleScalar({quantity: rawSeedRate.q, unit: rawSeedRate.u, unitType: 'seed-density'});

  const rawSeedTargetYield = getApplicationProperty(seedApplications, applicationProperties.TARGET_YIELD);
  const seedTargetYield = convertForLocaleScalar({
    quantity: rawSeedTargetYield.q,
    unit: rawSeedTargetYield.u,
    unitType: 'area-density.yield',
    cropNominalWeight: cropNominalWeight
  });

  return {liquidRate, seedRate, seedTargetYield};
};